import './App.css';
import PlayingNow from './PlayingNow.js';
import  {useState}  from "react";
import {useEffect} from "react";
import { useRef } from 'react';
import Show from './Show.js';
import SelectedShow from './SelectedShow.js';

import FullDaySchedule from './FullDaySchedule.js'; 
import NavigationBar from './NavigationBar.js';
import Popup from './Popup.js';
import Add from './Add.js';

function TopSection(props) {

  const isDebugMode = true;  
  const jsonRes = props.jsonRes;
  
  const jsonResS = props.jsonRes;
  
  let [nowPlaying, setNowPlaying] = useState(null);
  
  let [listComingUp, setListComingUp] = useState([]);

  const [activeDate, setActiveDate] = useState((new Date()));
  
  let [blackoutRules, setBlackoutRules] = useState(Array()); 

  const dateContainerRef  = useRef(null);

  let nowPlayingShowIndex = 0;
  console.log("Top section called");
  if(isDebugMode) console.log("jsonRes: ", jsonRes);

    useEffect(() => {

        //Runs only on the first render
        //console.log("Use effect called");
        try{
            (requestBlackout());
      
            //console.log(jsonRes);
            //setJsonRes(jsonRes);
            /***
             * Find the current playing show
             */
            let currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');  // Months are 0-indexed, so add 1
            const year = currentDate.getFullYear();
            //console.log("Loooking date" + (day+month+year));
            // Get the current hour
            let currentHour = currentDate.getHours();
            
            let currentMin = currentDate.getMinutes();
            let lookMin = '00';
            if(currentMin>=0 && currentMin<=30){
              lookMin= '00';
            }else{
              lookMin= '30';
            }
            //console.log("CURRNT HOUR " + currentHour + "Current Minute"+ currentMin + "Looking for Min "+ lookMin);

            nowPlayingShowIndex = (jsonRes.findIndex((show)=>{ 
              //console.log(show.start_time.substring(2, 4))
              if(show.start_time.substring(0, 2) == currentHour && show.start_time.substring(2, 4) == lookMin && show.date==(year+month+day)){
               //console.log("NOW PLAYING SHOW FOUND ");
           //     console.log(show.start_time.substring(0, 2));
             //   console.log(show.start_time.substring(2, 4))
              }
              return (show.start_time.substring(0, 2) == currentHour && show.start_time.substring(2, 4) == lookMin && show.date==(year+month+day));
        
            }));
           
            function findPrevIndex(currentDate, i){

                
              let alterDate = new Date();
              alterDate.setMinutes(currentDate.getMinutes() - 30*i); 

              const day = String(alterDate.getDate()).padStart(2, '0');
              const month = String(alterDate.getMonth() + 1).padStart(2, '0');  // Months are 0-indexed, so add 1
              const year = alterDate.getFullYear();
              //console.log("Loooking date" + (day+month+year));
              // Get the current hour
              let currentHour = alterDate.getHours();
              
              let currentMin = alterDate.getMinutes();
              let lookMin = '00';
              if(currentMin>=0 && currentMin<=30){
                lookMin= '00';
              }else{
                lookMin= '30';
              }
              //console.log("UPdated CURRNT HOUR " + currentHour + "Current Minute"+ currentMin + "Looking for Min "+ lookMin);

              nowPlayingShowIndex = jsonRes.findIndex((show)=>{ 
              
                return  (show.start_time.substring(0, 2) == currentHour && show.start_time.substring(2, 4) == lookMin && show.date==(year+month+day));
  
              });
              if(nowPlayingShowIndex===-1){
                //console.log("checking the call");
                findPrevIndex(currentDate, i+1);
              }
            }
            
            
            if(nowPlayingShowIndex===-1){
              //currentHour = currentHour-1;
              
              findPrevIndex(currentDate, 1);
            }else{

            }
            
            console.log("nowPlayingShowIndex at this point" + nowPlayingShowIndex)
            if(parseInt(jsonRes[nowPlayingShowIndex].duration, 10) >= 1800 ){
              //console.log(jsonRes[nowPlayingShowIndex]);
              setNowPlaying(jsonRes[nowPlayingShowIndex]);

              let tempList =[];
              for(let i= nowPlayingShowIndex+1; i<=(nowPlayingShowIndex+6); i++){
                tempList.push(jsonRes[i]);
              }
              //console.log(tempList);
              setListComingUp(tempList);

            }else{
              setNowPlaying(jsonRes[nowPlayingShowIndex + 1]);
              let tempList =[];
              for(let i= nowPlayingShowIndex+2; i<=(nowPlayingShowIndex+7); i++){
                //console.log(jsonRes[i].description);
                tempList.push(jsonRes[i]);
              }
              //console.log(tempList);
              setListComingUp(tempList);
            }


          
        
        }catch(err){
          console.log("Error in API call: "+ err);
        }
        
   }, []);


 
/***
 * 
 * Requests data about balckout
 * 
 * 
 */

function requestBlackout(){
  console.log("Requesting");

  const url = "https://www.chch.com/sched/get_blackout_json_dev.php?d=67";
      
      const response = fetch(url)
      .then(response => {
        if (!response.ok) {
          //throw new Error('Network response was not ok');
        }
        //console.log(response);
        
        return response.json();
      }).then(data => {
        
        setBlackoutRules((data['parrot-chch']['rules']))
        console.log("Set black out rules ");
      });
  }



    
    function ScrollToAllShows(){
      dateContainerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function clearFullDaySelectedShow(){

    }


          
    function showHeaderSection(sectionID){
         console.log("chnage State");
         console.log(sectionID);
        
         SetTopSectionState(previousState => {
            
            switch(sectionID){
                case "playingNow":
                    previousState.Active.playingNow = true; break
                case "primeTime":
                    previousState.Active.primeTime = true; break
                case "comingUp":
                    previousState.Active.comingUp = true; break
                    
             }
             return { ...previousState}
         });
        
    }

    const [TopSectionState, SetTopSectionState] = useState({
        
        Active: {"playingNow": false,
        "comingUp": false,
        "primeTime": false},
        "cursorLocation": 0
      });

    

      
if(nowPlaying=="" || listComingUp==null){
  console.log("now playing is null or coming up is null");
  return (
    <>
    <NavigationBar activeDate={activeDate}  setActiveDate={setActiveDate} ScrollToAllShows={ScrollToAllShows} jsonRes={jsonResS}/>
  <div  ref={dateContainerRef}>
    <FullDaySchedule  shows={jsonResS} activeDate={activeDate} blackoutData={blackoutRules} />
  </div></>
  );
}else{
  
  return (
    
    <> 

        <NavigationBar activeDate={activeDate}  setActiveDate={setActiveDate} ScrollToAllShows={ScrollToAllShows} jsonRes={jsonResS}/>
        <div id="middleSection" >
          
          <PlayingNow showSection={showHeaderSection}  display={TopSectionState.Active.playingNow} show={nowPlaying} blackoutData={blackoutRules}/>
            <Add/>
            <Break></Break>
          <ComingUp   showSection={showHeaderSection} display={TopSectionState.Active.comingUp} shows = {listComingUp} blackoutData={blackoutRules}/>
          
        </div>
        <Break></Break>
        <div  ref={dateContainerRef}>
          <FullDaySchedule  shows={jsonResS} activeDate={activeDate} blackoutData={blackoutRules} />
        </div>
      
    </>
      
  );

}


}


function ComingUp(props){

const [listComingUpShows, setListComingUp] = useState(comingUpShows());
const [selectedShow, setSelectedShow] = useState({});
const selectedShowForComingUp = useRef(null);
const [showPopup, setShowPopup] = useState(false);

  function handleShowClick(showKey){
    console.log(showKey);
    setSelectedShow(props.shows[showKey]);
   // selectedShowForComingUp.current.scrollIntoView({ behavior: 'smooth' });
    setShowPopup(!showPopup);
  }

  useEffect(()=>{
    let listofComingUpShows = props.shows.map((ele,index)=>{
      return (<Show handleShowClick={handleShowClick} show={ele} key={index} showIndex={index}/>)
  });
    
    setListComingUp(listofComingUpShows);
  }, [props]);

function comingUpShows(){
  let listofComingUpShows = props.shows.map((ele,index)=>{
    return (<Show handleShowClick={handleShowClick} show={ele} key={index} showIndex={index}/>)
  })
  return listofComingUpShows;
}


  const togglePopup = () => {
    setShowPopup(!showPopup);
    
  };
    return(
    <div className="ComingUpShowContainer" id="comingUpSection" onClick={ () => props.showSection("comingUp")} >

      <h2>Coming Up</h2>
       <Popup show={showPopup}  selectedShow={selectedShow} onClose={togglePopup} blackoutData={props.blackoutData}>
      
        </Popup>
      <div ref={selectedShowForComingUp} id="selectedShowForComingUp">
        
      </div>
      <div className="ShowsContainer" id="comingUpContainer" >{listComingUpShows}</div>
    </div>);
}

function Break(){
  return(<div className='break'></div>)
}
export default TopSection;